
import Vue from "vue";
import { baseVueController } from "./baseVueController";
import { ajax, dialogUtil, idb, lstorage, ui } from "./util";
import * as es6promise from "es6-promise";
import { editInfo } from "./entity/idb/editInfo";
import { masterInfo } from "./entity/idb/masterInfo";
import { orderInfo } from "./entity/idb/orderInfo";
import { constDialogMessage } from "./util/const";
import { AtenaParamEntity } from "./entity/GetAtenaParamEntity";
import { common } from "./util/common";
import { Logger } from "./util/logger";
import { MultiTab } from "./util/multitab";
import { util } from ".";
import { SSO } from "./util/sso";
import { AdjustRecord } from "./util/adjustRecord";

var that: any; // = this

// gigya
declare var gigya: any;

//------------------------------------------------------------------------------
// クラス
//------------------------------------------------------------------------------
/**
 * 宛名選択画面コントローラクラス
 * */
export class atenaSelectController extends baseVueController {

	//--------------------------------------------------------------------------
	// 定数
	//--------------------------------------------------------------------------
	private readonly ELEMENT_NAME: string = "#atenaSelectController";

	// idb関連
	private readonly EDIT_INFO_STORENAME: string = "editInfo";
	private readonly OREDER_INFO_STORENAME: string = "orderInfo";
	private readonly MASTER_INFO_STORENAME: string = "masterInfo";

	// WebAPIのエンドポイント定義
	private readonly WebAPI_OcapiLogin = "Login/Ocapi/";
	private readonly WebAPI_GIGYALogin = "Login/GIGYA/";
	private readonly WebAPI_GetAtenaParam: string = "Extr/GetAtenaParam";
	//private readonly WebAPI_AddCart: string = "Extr/AddCart"; // 次へ(カート連携)

	// 画面URL
	private readonly ViewURL_HagakiSelect: string = "HagakiSelect"; // 戻る

	//--------------------------------------------------------------------------
	// 変数
	//--------------------------------------------------------------------------
	// idb
	private _editInfo: editInfo;
	private _orderInfo: orderInfo;
	private _masterInfo: masterInfo;

	/**
	 * ロゴ１ URL
	 */
	private _logo1Url: string;
	/**
	 * ロゴ２ URL
	 */
	private _logo2Url: string;
	/**
	 * 説明書き
	 */
	private _description: string;
	/**
	 * バーコードを記すか？
	 */
	private _hasBarcode: boolean;
	/**
	 * 差出人を記すか？
	 */
	private _hasSender: boolean;
	/**
	 * バーコード説明書き
	 */
	private _barcodeDescription: string;
	/**
	 * 宛名単価
	 */
	private _unitPrice: string;

	// 宛名印刷するか？
	public _doPrintAtena: boolean = false;

	// token
	private _token: string;

	// GIGYAコールバック分岐用 true:一時保存、false:宛名に遷移
	private _isSave: boolean;

	//--------------------------------------------------------------------------
	// プロパティ
	//--------------------------------------------------------------------------

	//--------------------------------------------------------------------------
	// コンストラクタ
	//--------------------------------------------------------------------------

	//--------------------------------------------------------------------------
	// メソッド
	//--------------------------------------------------------------------------
	/**
	 * 初期化メソッド
	 * */
	public init(): void {

		// 複数タブ禁止
		const multiTabCheck = () => {
			MultiTab.forbiddenMultiTab(() => {
				dialogUtil.createErrorDialog(constDialogMessage.WARNING_MULTITAB_FORBIDDEN
					, () => { }
					, null
					, true
				);
			})
		}
		setInterval(multiTabCheck, MultiTab.INTERVAL);

		// エラー時のボタン遷移先
		this.SetErrorPageInfo();

		// gigya イベントリスナー登録
		if (this._retailerConfig.id == "0") {
			gigya.socialize.addEventHandlers({
				onLogin: this.onLoginHandler
				//onHide: common.onHideHandler
			});
		}

		// リテーラ毎の処理
		this.initRetailer();

		// thatセット
		that = this;

		// vueオブジェクト生成
		this._vue = new Vue({
			el: this.ELEMENT_NAME,
			data: {
				// ヘッダーメニュー
				Header: {
					Logo1Url: this._logo1Url,
					Logo2Url: this._logo2Url,
				},
				// 説明書き
				description: this._description,
				// バーコード記すか？
				hasBarcode: this._hasBarcode,
				// バーコード説明書き
				barcodeDescription: this._barcodeDescription,
				// 宛名の単価
				unitPrice: this._unitPrice,
				// 表示制御
				Show: {
					// 操作方法の表示(空の場合は表示しない)
					OperationInfo: this._retailerConfig.operationInfo.atenaSelect ? true : false,

					// 投函代行関連文言表示
					IsShowSupplement: (this._retailerConfig.id === "0" || this._retailerConfig.id === "36") ? true : false,
				}

			},
			methods: {
				btnClickReturnFlow: (event: JQueryEventObject) => {
					this.btnClickReturnFlow(event);
				},
				btnClickNextFlow: (event: JQueryEventObject) => {
					this.btnClickNextFlow(event);
				},
				notPrinting: (event: JQueryEventObject) => {
					this.notPrinting(event);
				},
				printing: (event: JQueryEventObject) => {
					this.printing(event);
				},
				// 一時保存
				btnClickSave: (event: JQueryEventObject) => {
					this.btnClickSave(event);
				},
				// 操作方法
				btnClickOperationHelp: (event: JQueryEventObject) => {
					this.btnClickOperationHelp(event);
				},
				// ヘッダー
				btnClickReturnTop: (event: JQueryEventObject) => {
					this.btnClickReturnTop(event);
				},
				btnClickFaq: (event: JQueryEventObject) => {
					this.btnClickFaq(event);
				},
				btnClickOrderHistory: (event: JQueryEventObject) => {
					this.btnClickOrderHistory(event);
				},
			},
			computed: {
				// はがきサンプルのサムネイルクラスを切り替える。
				getThumbnailClass: () => {
					if (this._hasBarcode) {
						if (this._hasSender) {
							// バーコードあり、差出人あり
							return 'hagakiSample'
						} else {
							// バーコードあり、差出人なし
							return 'hagakiSampleNoSender'
						}
					} else {
						if (this._hasSender) {
							// バーコードなし、差出人あり
							return 'hagakiSampleNonBarcode'
						} else {
							// バーコードなし、差出人なし
							return 'hagakiSampleNonBarcodeNoSender'
						}
					}
				}
			},
			mounted: () => {

				// リテーラ別のチャットボット制御
				var divChatBot = document.getElementById("chava-root") as HTMLDivElement;
				if (divChatBot) {
					divChatBot.style.display = this._retailerConfig.id == "0" ? "block" : "none";
				}

				$(".supplementPrint").removeClass("disp-none");

				// DOM読み込み後
				this.doOnload();

			}
		});
	}

	/**
	 * リテーラ別の初期化処理
	 * */
	public initRetailer(): void {
		// リテーラロゴURL設定
		this._logo1Url = this._retailerConfig.logo1;
		this._logo2Url = this._retailerConfig.logo2;

		// 説明書き設定
		this._description = this._retailerConfig.poscaSettings.atenaViewSettings.description.join('<br>');
		if (this._retailerConfig.poscaSettings.atenaViewSettings.hasBarcode) {
			this._hasBarcode = true;
			this._barcodeDescription = this._retailerConfig.poscaSettings.atenaViewSettings.barcodeDescription.join('<br>');
		}
		this._hasSender = this._retailerConfig.poscaSettings.atenaViewSettings.hasSender;

		// 単価設定
		this._unitPrice = this._retailerConfig.poscaSettings.atenaViewSettings.unitPrice.toString();

	}

	/**
	 * 画面の初期化
	 * */
	private async doOnload(): es6promise.Promise<void> {

		dialogUtil.showLoading();

		// tokenを画面から確保
		this.getAuthToken();

		// SSO
		Logger.log("SSO開始");
		await SSO.DoSSO(this._token, this._retailerConfig.id);

		// idbからのデータ読み込み
		this.loadIDB().then(() => {

			// ダイアログ閉じ
			dialogUtil.closeLoading();
			Logger.log("idb読み込み完了。");

		}).catch((msg) => {
			// idb系エラー
			dialogUtil.createErrorDialog(msg, dialogUtil.closeErrorDialog);
			return es6promise.Promise.reject;
		});
	}

	/**
	 * indexedDBからの読み込み
	 * */
	private async loadIDB(): es6promise.Promise<string> {

		// 編集情報のデータ取得
		this._editInfo = lstorage.get<editInfo>(lstorage.KEY_EDIT, true);
		if (!this._editInfo) {
			// 読み込み失敗
			return es6promise.Promise.reject<string>(constDialogMessage.ERROR_LOCAL_DB_READ);
		}

		// 注文情報のデータ取得
		this._orderInfo = lstorage.get<orderInfo>(lstorage.KEY_ORDER, true);
		if (!this._orderInfo) {
			// 読み込み失敗
			return es6promise.Promise.reject<string>(constDialogMessage.ERROR_LOCAL_DB_READ);
		}

	}

	/**
	 * 宛名印刷ボタンの制御＆フラグ更新
	 * @param printFlg
	 */
	private changePrintState(printFlg: boolean): void {

		const printId = "#printingBtn";
		const notPrintId = "#notPrintingBtn";

		if (printFlg) {
			$(notPrintId).removeClass("selected");
			$(printId).addClass("selected");
			this._doPrintAtena = true;
		} else {
			$(notPrintId).addClass("selected");
			$(printId).removeClass("selected");
			this._doPrintAtena = false;
		}

	}

	/**
	 * 宛名遷移用のパラメータ取得
	 * */
	private async getAtenaParam(isAnotherName: boolean): es6promise.Promise<any> {
		return new es6promise.Promise((res, rej) => {
			var model = {
				token: this._token,
				callBackURL: window.location.href,
				doCopy: isAnotherName,
				showBackBtn: true
			}

			dialogUtil.showLoading();

			ajax.post(this.WebAPI_GetAtenaParam, JSON.stringify(model))
				.then((data: AtenaParamEntity) => {
					res(data);
				}).catch(() => {
					rej("");
				}).finally(() => {
					//dialogUtil.closeLoading();

				});
		});
	}

	/**
	 * 認証トークン取得
	 */
	public getAuthToken(): string {

		// hiddenから認証トークン取得＆クリア
		this._token = $("#Token").val();
		//$("#Token").val("");
		return this._token;

	}

	/**
	 * GIGYAのログインダイアログコールバック
	 * @param event
	 */
	private async onLoginHandler(res: any): es6promise.Promise<any> {

		// ここではthis使えないのでthatで代替

		dialogUtil.showLoading();

		Logger.log('gigya callback 呼び出し。');

		const param = {
			token: that._token,
			uid: res.UID,
			signature: res.UIDSignature,
			sigtimestamp: res.signatureTimestamp,
		};

		// GIGYAログインのシグネイチャ検証
		await ajax.post(that.WebAPI_GIGYALogin, JSON.stringify(param)).catch((e) => {
			dialogUtil.createErrorDialog(constDialogMessage.ERROR_GIGYA_SIGNATURE_INVALID, dialogUtil.closeErrorDialog);
			dialogUtil.closeLoading();
			// 検証失敗。
			throw e;
		});

		// CCとGIGYA間のログイン
		await ajax.postform(that._retailerConfig.extrSettings.commersCloud.gigyaCcBridge, res.UID).catch((e) => {
			dialogUtil.createErrorDialog(constDialogMessage.ERROR_CC_LOGIN_WITH_GIGYA, dialogUtil.closeErrorDialog);
			dialogUtil.closeLoading();
			throw e;
		});

		that.afterGIGYACallback();

	}

	/**
	 * GIGYAコールバックの後に呼ぶ処理
	 * */
	public afterGIGYACallback(): void {
		// カスタマーIDはサーバで取得

		if (that._isSave) {

			// 一時保存
			common.SaveToCommersCloud(that._token);

		} else {

			// 保存ダイアログの後のコールバック
			let func = function () {
				
				// 宛名印刷する。 -> 上書き/別名問わず、常に宛名データはコピーする。
				that.getAtenaParam(true).then((data: AtenaParamEntity) => {

					dialogUtil.showLoading();

					var form = document.createElement('form');

					// rs
					var ele1 = document.createElement('input');
					ele1.setAttribute("type", "hidden");
					ele1.setAttribute("name", "rs");
					ele1.setAttribute("value", data.rs);
					form.appendChild(ele1);

					// sign
					var ele1 = document.createElement('input');
					ele1.setAttribute("type", "hidden");
					ele1.setAttribute("name", "sign");
					ele1.setAttribute("value", data.sign);
					form.appendChild(ele1);

					// 宛名印刷する
					form.action = data.atenaURL;

					form.method = 'POST';
					$('body').append(form);
					form.submit();

				}).catch(() => {
					dialogUtil.closeLoading();
					dialogUtil.createErrorDialog(constDialogMessage.ERROR_TRANS_ATENA, dialogUtil.closeErrorDialog);
				}).finally(() => {

				});
			}

			// 名前を付けて保存ダイアログ
			common.SaveToCommersCloud(that._token, func);
		}
	}

	//--------------------------------------------------------------------------
	// イベント
	//--------------------------------------------------------------------------
	/**
	* 前画面遷移ボタン押下メソッド
	* */
	public btnClickReturnFlow(event: JQueryEventObject): void {
		var form = document.createElement('form');
		form.action = this.ViewURL_HagakiSelect;
		form.method = 'POST';
		$('body').append(form);

		form.submit();
		//history.back();
	}

	/**
	 * 次画面遷移ボタン押下メソッド
	 * */
	public btnClickNextFlow(event: JQueryEventObject): void {

		// GIGYA分岐
		this._isSave = false;

		dialogUtil.showLoading();

		if (this._doPrintAtena) {

			// ログインチェックと保存
			common.SaveData(this._token, this._editInfo, this._orderInfo, this.afterGIGYACallback).finally(() => {

				// adjust登録
				try {
					new AdjustRecord(
						this._retailerConfig.extrSettings.adjust?.token,
						this._retailerConfig.extrSettings.adjust?.eventID.editEnd);
				} catch(er) {
					Logger.error(`AdjustError:${er}`);
				}

				dialogUtil.closeLoading();
			});

		} else {

			// 宛名無しのadjust連携はカート追加の共通処理で実施

			// カート遷移→強制保存
			common.SaveDataForceForCart(this._token);
		}

	}

	/**
	 * ボタン切り替え(印刷する)
	 */
	public printing(event: JQueryEventObject): void {
		this.changePrintState(true);
	}

	/**
	 * ボタン切り替え(印刷しない)
	 */
	public notPrinting(event: JQueryEventObject): void {
		this.changePrintState(false);
	}

	/**
	 * 一時保存ボタン押下メソッド
	 * */
	public btnClickSave(event: JQueryEventObject): void {

		// GIGYA分岐
		this._isSave = true;

		//idb.get(this.EDIT_INFO_STORENAME).then((editInfo: editInfo) => {
		//	idb.get(this.OREDER_INFO_STORENAME).then((orderInfo: orderInfo) => {
		//		common.SaveData(this._token, editInfo, orderInfo);
		//	});
		//});

		const editInfo: editInfo = lstorage.get<editInfo>(lstorage.KEY_EDIT, false);
		const orderInfo: orderInfo = lstorage.get<orderInfo>(lstorage.KEY_ORDER, false);
		common.SaveData(this._token, editInfo, orderInfo);
	}

	/**
	 * 操作方法ボタン押下メソッド
	 * */
	public btnClickOperationHelp(event: JQueryEventObject): void {

		ui.windowOpen(this._retailerConfig.operationInfo.atenaSelect, "", null, null);

	}


}
